export default "__VITE_ASSET__4He6C80i__"